import { type FC, type SVGProps } from 'react';
import { type SocialLink } from '@cx-web/components/composites';
import { FacebookFooter, Instagram, Tiktok, X, YoutubeFooter } from '@cx-web/components/primitives/icons';

type SocialLinkTemplate = {
  SvgIcon: FC<SVGProps<SVGSVGElement>>;
  linkLabel: string;
  name: string;
};

// All social links in order: New icons (YouTube, TikTok) prepended to left,
// then regular icons (Facebook, Instagram, X) in their original order
const SOCIAL_LINK_TEMPLATES: SocialLinkTemplate[] = [
  {
    SvgIcon: YoutubeFooter,
    linkLabel: 'CX_SOCIAL_YOUTUBE_ACCOUNT',
    name: 'youtube',
  },
  {
    SvgIcon: Tiktok,
    linkLabel: 'CX_SOCIAL_TIKTOK_ACCOUNT',
    name: 'tiktok',
  },
  {
    SvgIcon: FacebookFooter,
    linkLabel: 'CX_SOCIAL_FACEBOOK_ACCOUNT',
    name: 'facebook',
  },
  {
    SvgIcon: Instagram,
    linkLabel: 'CX_SOCIAL_INSTAGRAM_ACCOUNT',
    name: 'instagram',
  },
  {
    SvgIcon: X,
    linkLabel: 'CX_SOCIAL_X_ACCOUNT',
    name: 'x',
  },
];

export const getSocialLinks = (t: (key: string) => string): SocialLink[] =>
  SOCIAL_LINK_TEMPLATES.flatMap(({ SvgIcon, linkLabel, name }) => {
    const href = t(linkLabel);
    // Hide if translation is missing (i18next returns the key itself when untranslated)
    return href && href !== linkLabel ? [{ SvgIcon, href, name }] : [];
  });
